import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Routes from "./routes";
import "./App.css";
import configs from "./configs";
import ApplicationProvider from "./provider";
import { AppErrorBoundary } from "./components/error/ErrorBoundary";

function App() {
  return (
    <AppErrorBoundary>
      <HelmetProvider>
        <Helmet>
          <title>{configs.name}</title>
        </Helmet>
        <ApplicationProvider>
          <Routes />
        </ApplicationProvider>
      </HelmetProvider>
    </AppErrorBoundary>
  );
}

export default App;
